import React from "react";

export default function WorkWeekSix() {
  const weeks = [1, 2, 3, 4, 5];
  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  return (
    <>
      <style>{`
        .ww6-wrapper {
          padding: 10px 16px;
        //   background: #f4f6f9;
          font-family: "Segoe UI", sans-serif;
        }

        .ww6-card {
          max-width: 1200px;
          margin: auto;
          background: #ffffff;
          border-radius: 14px;
          padding: 24px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.08);
        }

        .ww6-title {
          text-align: center;
          font-size: 28px;
          font-weight: 700;
          margin-bottom: 6px;
          letter-spacing: 1px;
        }

        .ww6-subtitle {
          text-align: center;
          font-size: 15px;
          color: #555;
          margin-bottom: 10px;
        }

        .ww6-date {
          text-align: center;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .ww6-table-wrap {
          overflow-x: auto;
        }

        .ww6-table {
          width: 100%;
          border-collapse: collapse;
          min-width: 850px;
        }

        .ww6-table th {
          background: #eaf2ff;
          color: #222;
          padding: 14px;
          font-size: 14px;
          border: 1px solid #ddd;
        }

        .ww6-table td {
          padding: 18px;
          text-align: center;
          border: 1px solid #ddd;
        }

        .ww6-week {
          font-weight: 600;
        }

        .dot {
          width: 20px;
          height: 20px;
          border-radius: 4px;
          margin: auto;
        }

        .working {
          background: #0a8f08;
        }

        .off {
          background: #e10600;
        }

        .half {
          background: #ffd500;
        }

        .ww6-legend {
          display: flex;
          gap: 24px;
          margin-top: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 500;
        }

        @media (max-width: 768px) {
          .ww6-title {
            font-size: 22px;
          }

          .ww6-card {
            padding: 18px;
          }
        }
      `}</style>

      <div className="ww6-wrapper">
        <div className="ww6-card">
          <div className="ww6-title">WORK WEEK 6</div>
          <div className="ww6-subtitle">
            This is a 6-day Work Week rule with Weekly off set as Sunday.
          </div>
          <div className="ww6-date">Effective Date: 05 Feb, 2025</div>

          <div className="ww6-table-wrap">
            <table className="ww6-table">
              <thead>
                <tr>
                  <th>Week</th>
                  {days.map((day, i) => (
                    <th key={i}>{day}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {weeks.map((week) => (
                  <tr key={week}>
                    <td className="ww6-week">{week}</td>
                    {days.map((day, i) => (
                      <td key={i}>
                        <div
                          className={`dot ${
                            day === "Sun" ? "off" : "working"
                          }`}
                        ></div>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="ww6-legend">
            <div className="legend-item">
              <div className="dot working"></div> Working Day
            </div>
            <div className="legend-item">
              <div className="dot off"></div> Weekly Off
            </div>
            <div className="legend-item">
              <div className="dot half"></div> Half Day
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
